<template>
  <section class="update-password-view">
      <FloatingHeader
        title="Alterar senha"
        sbtitle="Atualize sua senha"
        :showHeader="true"
        :hideSearch="true"
        :routeToBack="'profile'"
      ></FloatingHeader>
      <div class="updt-pass-container">
          <h1>
            <span>*</span> Campos obrigatórios
          </h1>
          <InputContainer :inputs="fields" ref="updateInputs" />
          <div class="button-cont">
            <DefaultButton :text="'Atualizar'" :disabled="false" @defaultBtnClick="update()" :large="true">
            </DefaultButton>
          </div>
      </div>
  </section>
</template>

<script>
import FloatingHeader from '@/components/FloatingHeader.vue'
import InputContainer from '@/components/inputs/InputContainer.vue'
import DefaultButton from '@/components/buttons/DefaultButton.vue'
import { changePassword } from '@/assets/controllers/ConsumerController.js'
import Util from '@/assets/libs/util'

export default {
  name: 'UpdatePasswordView',
  components: {
    FloatingHeader,
    InputContainer,
    DefaultButton
  },
  data () {
    return {
      fields: [
        {
          display: 'Senha atual',
          placeholder: 'Senha',
          type: 'password',
          required: true
        },
        {
          display: 'Nova senha',
          placeholder: 'Nova senha',
          type: 'password',
          required: true
        },
        {
          display: 'Confirmar nova senha',
          placeholder: 'Confirmar a senha',
          type: 'password',
          required: true
        }
      ]
    }
  },
  methods: {
    update () {
      const values = this.$refs.updateInputs.getValues()

      const oldPassword = values[0]?.value
      const newPassword = values[1]?.value
      const newPasswordConfirmation = values[2]?.value

      if (!oldPassword || !newPassword || !newPasswordConfirmation) {
        Util.showWarningNotification({
          title: 'Preencha todos os campos.',
          text: ''
        })
        return false
      }

      if (newPassword !== newPasswordConfirmation) {
        Util.showWarningNotification({
          title: 'A nova senha e a confirmação devem ser iguais.',
          text: ''
        })
        return false
      }

      changePassword(oldPassword, newPassword)
        .then((res) => {
          if (res.error) {
            Util.showErrorNotification({
              title: res.message,
              text: ''
            })
            return false
          } else if (res.data?.result) {
            Util.showSuccessNotification({
              title: 'Senha alterada com sucesso.',
              text: ''
            })
            this.$router.push('/profile')
          }
        })
        .catch((err) => {
          Util.showWarningNotification({
            title: err,
            text: ''
          })
        })
    }
  }
}
</script>

<style lang="less" scoped>
.update-password-view {
  padding: 80px 20px 170px 20px;

  h1 {
    font-size: 12px;
    font-weight: normal;
    margin-bottom: 20px;

    span {
      color: var(--primaryColor);
    }
  }

  .button-cont {
    position: fixed;
    bottom: 0;
    left: 0;
    display: flex;
    width: -webkit-fill-available;
    align-items: flex-start;
    justify-content: center;
    background: white;
    animation: upper-in 0.4s;
    padding: 35px 0 60px 0;
    filter: drop-shadow(2px 4px 4px black);

    button {
      color: white;
      background-color: var(--primaryColor);
      border: none;
      border-radius: 5px;
      height: 50px;
      width: 80vw;

      span {
        font-weight: lighter !important;
        font-size: 16px !important;
      }
    }
  }
}

</style>
